module.exports = __webpack_public_path__ + "img/emoji-poop-80x80.314fa642.png";